import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Save } from "lucide-react";

const FIELDS = [
  { name: "ime_prezime", label: "Ime i prezime" },
  { name: "radno_mjesto", label: "Radno mjesto", placeholder: "npr. učitelj/ica matematike" },
  { name: "skola_naziv", label: "Naziv škole", placeholder: "npr. Osnovna škola Ivana Gundulića" },
  { name: "skola_adresa", label: "Adresa škole", placeholder: "Ulica i broj, poštanski broj i mjesto" },
  { name: "mjesto", label: "Mjesto", placeholder: "npr. Zagreb" },
];

export default function ProfileDialog({ open, onOpenChange, profile, onSave }) {
  const [form, setForm] = useState(profile);

  useEffect(() => {
    if (open) setForm(profile);
  }, [open, profile]);

  const handleLogo = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, 480 / img.width, 200 / img.height);
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        setForm((p) => ({ ...p, logo: canvas.toDataURL("image/png") }));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="profile-dialog">
        <DialogHeader>
          <DialogTitle>Moj profil</DialogTitle>
          <DialogDescription>
            Podaci se spremaju samo lokalno, u vašem pregledniku, i služe za brzo popunjavanje
            obrazaca. Ne vide ih ni administratori Školske zbornice niti bilo tko drugi.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3.5 mt-1">
          {FIELDS.map((f) => (
            <div key={f.name}>
              <label className="papir-label">{f.label}</label>
              <input
                data-testid={`profile-${f.name.replace(/_/g, "-")}-input`}
                className="papir-input"
                placeholder={f.placeholder || ""}
                value={form[f.name] || ""}
                onChange={(e) => setForm((p) => ({ ...p, [f.name]: e.target.value }))}
              />
            </div>
          ))}
          <div>
            <label className="papir-label">Logotip škole (prikazuje se u zaglavlju dokumenata, nije obavezno)</label>
            {form.logo ? (
              <div className="flex items-center gap-3">
                <img
                  src={form.logo}
                  alt="Logotip škole"
                  className="h-12 border border-slate-200 rounded-lg p-1 bg-white"
                  data-testid="profile-logo-preview"
                />
                <button
                  type="button"
                  data-testid="profile-logo-remove"
                  onClick={() => setForm((p) => ({ ...p, logo: undefined }))}
                  className="text-sm text-red-600 hover:underline"
                >
                  Ukloni
                </button>
              </div>
            ) : (
              <input
                type="file"
                accept="image/*"
                data-testid="profile-logo-input"
                onChange={handleLogo}
                className="papir-input"
              />
            )}
          </div>
          <button
            data-testid="profile-save-button"
            onClick={() => onSave(form)}
            className="w-full flex items-center justify-center gap-2 bg-blue-700 hover:bg-blue-800 text-white font-semibold px-5 py-2.5 rounded-xl shadow-sm transition-all mt-2"
          >
            <Save className="w-4 h-4" />
            Spremi profil
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
